module.exports = __webpack_public_path__ + "static/img/form@2x.4f4f3422.png";